<script setup lang="ts">
import { useSurveyStore } from 'src/store';
import { SurveyTypeEnum } from 'src/constants/survey';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const {t} = useI18n();

const surveyModule = useSurveyStore();

const surveyThankYouTitle = computed(() => {
  if (
    surveyModule.surveyDefinition?.surveyType === SurveyTypeEnum.Pain_and_Opioid_Pre_Op ||
    surveyModule.surveyDefinition?.surveyType === SurveyTypeEnum.Pain_and_Opioid_Post_Op
  ) {
    return t('checkin_complete_title').toString();
  } else {
    return t('survey_completed').toString();
  }
});

const surveyThankYouBody = computed(() => {
  if (surveyModule.surveyDefinition?.surveyType === SurveyTypeEnum.Pain_and_Opioid_Pre_Op) {
    return reFormatString(t('checkin_complete_preop_body').toString());
  } else if (
    surveyModule.surveyDefinition?.surveyType === SurveyTypeEnum.Pain_and_Opioid_Post_Op
  ) {
    return reFormatString(t('checkin_complete_body').toString()).replace('\\', '');
  } else {
    return t('survey_submit').toString();
  }
});

const surveyThankYouList = computed(() => {
  if (
    surveyModule.surveyDefinition?.surveyType === SurveyTypeEnum.Pain_and_Opioid_Pre_Op ||
    surveyModule.surveyDefinition?.surveyType === SurveyTypeEnum.Pain_and_Opioid_Post_Op
  ) {
    return reFormatString(t('checkin_disclaimer_painmgmt').toString());
  }

  return '';
});

function reFormatString(str: string) {
  return str.replace(/\\n/g, '<br />');
}
</script>

<template>
  <div class="row bs-gutter justify-center text-center survey__submit">
    <div class="col-auto">
      <h1 class="mb-50">{{ surveyThankYouTitle }}</h1>
      <q-icon class="mb-50" color="primary" name="fa-light fa-circle-check" size="132px" />
      <p v-html="surveyThankYouBody" />
      <p v-if="surveyThankYouList" v-html="surveyThankYouList" class="text-left" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use 'sass:map';

.survey {

  // Submit
  &__submit {

    > [class*="col"] {
      flex-basis: 100%;
      width: 100%;
      max-width: 600px;
    }

    p {
      font-size: map.get($font-sizes, '20');
      line-height: $line-height-md;
    }
  }
}
</style>
